import React from 'react';
import '../../styles/explore.scss';

function QuestionBlock({ id, question, children, unconfirmed }) {
	if (!children && !unconfirmed) return null;
	return (
		<section className="question-block" id={id}>
			<h2 className="question-block__question">{question}</h2>
			<div className={`question-block__answer${unconfirmed ? ' question-block__answer--pending' : ''}`}>
				{children || <p className="text-muted mb-0">We haven&apos;t confirmed this yet — check back as we expand our Nepal knowledge base.</p>}
			</div>
		</section>
	);
}

export default QuestionBlock;
